export default __webpack_public_path__ + "16081481a178a165e6206d60020a6237.png";